import { createContext } from "react";
import type { SelectedDashboard } from "../DashboardProvider.types";

const TargetDashboardContext = createContext<SelectedDashboard | null | undefined>(undefined);
TargetDashboardContext.displayName = "TargetDashboardContext";

export default TargetDashboardContext;
